module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "ct"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062305589_Epigraph#epi01",
      "id": "epi01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062305589_Preface#pre01",
      "id": "pre01"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Preface by Frances Goldin")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062305589_Introduction#int01",
      "id": "int01"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Introduction by Debby Smith and Michael Steven Smith")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062305589_Section_1#sec1",
      "id": "sec1"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Section 1: What’s Wrong with Capitalism?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062305589_Chapter_1#cha1",
      "id": "cha1"
    }
  }, [_vm._v("1. Capitalism: The Real Enemy by Paul Street")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062305589_Section_2#sec2",
      "id": "sec2"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Section 2: Imagining Socialism")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062305589_Chapter_2#cha2",
      "id": "cha2"
    }
  }, [_vm._v("2. The Future Will Be Ecosocialist, Because Without Ecosocialism, There Will Be No Future by Joel Kovel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062305589_Chapter_3#cha3",
      "id": "cha3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. A Democratically Run Economy Can Replace the Oligarchy by Ron Reosti")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062305589_Chapter_4#cha4",
      "id": "cha4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. The Shape of a Post-Capitalist Future by Rick Wolff")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062305589_Chapter_5#cha5",
      "id": "cha5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Law in a Socialist USA by Michael Steven Smith")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062305589_Chapter_6#cha6",
      "id": "cha6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Alternatives to the Present System of Capitalist Injustice by Mumia Abu-Jamal and Angela Davis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062305589_Chapter_7#cha7",
      "id": "cha7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Socialism Is the Highest Expression of Human Rights by Ajamu Baraka")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062305589_Chapter_8#cha8",
      "id": "cha8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Personal, Emotional, and Sexual Life Without Capitalism by Harriet Fraad and Tess Fraad-Wolff")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062305589_Chapter_9#cha9",
      "id": "cha9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. A Woman’s Workday in a Socialist USA by Renate Bridenthal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062305589_Chapter_10#cha10",
      "id": "cha10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Dignity, Respect, Equality, Love by Blanche Wiesen Cook")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062305589_Chapter_11#cha11",
      "id": "cha11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. How Queer Life Might Be Different in a Socialist USA by Leslie Cagan and Melanie Kaye/Kantrowitz")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062305589_Chapter_12#cha12",
      "id": "cha12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Drugs in a Society Where People Care About Each Other by Steven Wishnia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062305589_Chapter_13#cha13",
      "id": "cha13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Immigration: Immigrant Workers Point the Way to a Better World by Juan Gonzalez")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062305589_Chapter_14#cha14",
      "id": "cha14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Welfare in a New Society: An End to Intentional Impoverishment and Degradation by Frances Fox Piven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062305589_Chapter_15#cha15",
      "id": "cha15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Food for All: Creating a Socially Sustainable Food System by Arun Gupta")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062305589_Chapter_16#cha16",
      "id": "cha16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. The Right to Housing by Tom Angotti")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062305589_Chapter_17#cha17",
      "id": "cha17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Socialized Medicine Means Everyone Gets Care, Regardless of Whether They Have Money by Dave Lindorff")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062305589_Chapter_18#cha18",
      "id": "cha18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. Teach Freedom! by William Ayers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062305589_Chapter_19#cha19",
      "id": "cha19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. Imagining Art After Capitalism by Mat Callahan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062305589_Chapter_20#cha20",
      "id": "cha20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. Prometheus Completely Unbound: What Science and Technology Could Accomplish in a Socialist America by Clifford D. Conner")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062305589_Chapter_21#cha21",
      "id": "cha21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. First-Class News: The Media in a Socialist USA by Fred Jerome")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062305589_Section_3#sec3",
      "id": "sec3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Section 3: Getting There: How to Make a Socialist America")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062305589_Chapter_22#cha22",
      "id": "cha22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. Where Does Occupy Wall Street Go from Here? A Proposal by Michael Moore")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062305589_Chapter_23#cha23",
      "id": "cha23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. What I Would Do as Attorney General by Michael Ratner")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062305589_Chapter_24#cha24",
      "id": "cha24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24. We Be Reading Marx Where We From: Socialism and the Black Freedom Struggle by Kazembe Balagun")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062305589_Chapter_25#cha25",
      "id": "cha25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25. The Working-Class Majority by Michael Zweig")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062305589_Chapter_26#cha26",
      "id": "cha26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26. How to Achieve Economic Democracy in the United States by Clifford D. Conner")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062305589_Chapter_27#cha27",
      "id": "cha27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27. The Capitalist Road: From Chinese Sweatshops to Detroit’s Decay by Dianne Feeley")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062305589_Chapter_28#cha28",
      "id": "cha28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28. The Third American Revolution: How Socialism Can Come to the United States by Paul Le Blanc")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062305589_Chapter_29#cha29",
      "id": "cha29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29. Imagine the Angels of Bread by Martín Espada")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062305589_Chapter_30#cha30",
      "id": "cha30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30. Thanksgiving 2077: A Short Story by Terry Bisson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062305589_Chapter_31#cha31",
      "id": "cha31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31. You Are the Light of the World: Speech Via Mic Check at Occupy Wall Street by Joel Kovel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062305589_Contributors#con01",
      "id": "con01",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Contributors’ Biographies")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062305589_Index#ind01",
      "id": "ind01",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062305589_Praise#pra01",
      "id": "pra01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for IMAGINE: Living in a Socialist USA")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062305589_Copyright#cop01",
      "id": "cop01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Publisher#atp01",
      "id": "atp01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Publisher")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8ed09b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062305589_Contents.vue
// module id = 66
// module chunks = 0